<div id="error-page-container">
    <div id="text-container">
        <h1 class="title">{{ 'pageNotFound.title' | translate }}</h1>

        <div class="content">
            <p>{{ 'pageNotFound.firstSentence' | translate }} {{ pageNotFoundData.content | translate }}</p>
            <p>
                <span [innerHtml]="'pageNotFound.secondSentence' | translate"></span
                ><span class="link">888-321-2113</span>.
            </p>
        </div>

        <div class="action-buttons">
            <button
                id="go-to-dashboard-btn"
                pButton
                type="button"
                class="p-button p-button-lg"
                aria-label="Go To Previous Page"
                [label]="
                    ('pageNotFound.backTo.button.text' | translate) +
                    ' ' +
                    (pageNotFoundData.previousPageTitle | translate)
                "
                (click)="goToPreviousLink()"></button>
            <button
                id="live-chat-btn"
                pButton
                type="button"
                icon="far fa-comments"
                class="p-button-outlined p-button-lg"
                aria-label="Live Chat Button"
                [label]="'pageNotFound.liveChat.button.text' | translate"
                (click)="openChat()"></button>
        </div>
    </div>

    <div id="image-container">
        <img
            width="800"
            height="439"
            [ngSrc]="'assets/images/illustrations/error_404.svg'"
            [alt]="'img.alt.pageNotFound' | translate" />
    </div>
</div>
